import { render } from "./ModalCrypto.vue?vue&type=template&id=65fc0659&scoped=true"
import script from "./ModalCrypto.vue?vue&type=script&lang=js"
export * from "./ModalCrypto.vue?vue&type=script&lang=js"

import "./ModalCrypto.vue?vue&type=style&index=0&id=65fc0659&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65fc0659"]])

export default __exports__